import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Redirect, RouteComponentProps } from "react-router";
import styled from "styled-components";
import VenuePreview from "sweet-web/components/universal/VenuePreview";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";

const Wrapper = styled.div`
  width: calc(100% + 20px);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: flex-start;
  padding: 40px 0;
  margin-left: -10px;
  margin-right: -10px;
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const MyListings: React.FC<Props> = props => {
  const { myVenues, loading, userType } = props;

  if (Object.keys(myVenues).length === 1 && window.innerWidth > 600) {
    return <Redirect to={`/listing/${Object.keys(myVenues)[0]}`} />;
  }

  return (
    <Wrapper>
      {Object.keys(myVenues).map(myVenueId => {
        const venue = myVenues[myVenueId];
        const previewVenue = () => props.history.push(`/listing/${myVenueId}`);

        return (
          <VenuePreview
            key={`my-venues-venue-preview-${myVenueId}`}
            venue={venue}
            onClick={previewVenue}
            admin={userType === "ADMIN"}
          />
        );
      })}
    </Wrapper>
  );
};

const mapState = (state: RootState) => ({
  myVenues: selectors.myVenues(state),
  loading: selectors.isGettingMyVenues(state),
  userType: selectors.userType(state)
});
const connector = connect(mapState);

export default connector(MyListings);
